import { Plugin } from 'hubspot-prosemirror/pm/state';
import { EditorView } from 'hubspot-prosemirror/pm/view';
import { setTrSelectionPosition } from '../utils/documentUtils';

type FocusPluginState = {
  focusView?: boolean;
  focusViewPos?: number;
  preserveSelection?: boolean;
};

/**
 * TODO: move this into state for the FocusPlugin
 */
// eslint-disable-next-line no-restricted-syntax
let focusPluginState: FocusPluginState;

export const FocusPlugin = new Plugin({
  state: {
    init() {
      return {};
    },
    apply(tr, currentPluginState) {
      const meta = tr.getMeta(FocusPlugin);
      if (meta) {
        focusPluginState = meta;
        return meta;
      }
      return currentPluginState;
    },
  },
  view() {
    return {
      update: (view: EditorView) => {
        if (focusPluginState && focusPluginState.focusView) {
          // only focus if it isn't currently focused
          window.requestAnimationFrame(() => {
            const active = document.activeElement;
            if (
              active instanceof HTMLElement &&
              (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA') &&
              !view.dom.contains(active)
            ) {
              focusPluginState = {};
              return;
            }
            if (!focusPluginState.preserveSelection && view.hasFocus()) {
              return;
            }
            if (!view.hasFocus()) {
              view.focus();
            }
            const tr = focusPluginState.preserveSelection
              ? view.state.tr
              : setTrSelectionPosition(
                  view.state.tr,
                  focusPluginState.focusViewPos
                );
            view.dispatch(tr);
            focusPluginState = {};
          });
        }
      },
    };
  },
});
